import { Box, Heading, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import styles from "./Css/GIthub.module.css";
import GitHubCalendar from "react-github-calendar";


export default function Github() {


  return (
    <Box
    id="github"
      m="auto"
      mt="10px"
      borderRight="20px solid royalBlue"
      className={styles.GitHubBody}
    >
      <Heading
        id="github"
        fontSize={{ base: "80px", sm: "140px", md: "230px" }}
        color={useColorModeValue("gray.300", "gray.600")}
        className={styles.githubHeading}
        fontFamily="'Playfair Display', serif"
        mb={{ base: "-20px", sm: "-40px", md: "-120px" }}
      >
        Github
      </Heading>

      <SimpleGrid
        // bg="red.300"
        spacing="0px"
        maxW="1248px"
        columns={{ sm: 1, md: 1 }}
        m="auto"
      >
        <SimpleGrid
          // bg="red.300"
          spacing="20px"
          maxW="1248px"
          columns={{ sm: 1, md: 2 }}
          m="auto"

        >
          <Box m="auto" bg="" borderRadius="5px" border="2px solid black">
            <img
              maxW="624px"
              align="center"
              src="https://github-readme-streak-stats.herokuapp.com/?user=AshishKohad27&show_icons=true&theme=dark"
              alt="ashishkohad27Stats"
            />
          </Box>
          <Box m="auto" borderRadius="5px" border="2px solid black" >
            <img
              borderRadius="20px"
              border="2px solid white"
              maxW="624px"
              align="center"
              bg="gray.700"
              src="https://github-readme-stats.vercel.app/api?username=AshishKohad27&&show_icons=true&theme=dark"
              alt="ashishkohad27"
            />
          </Box>
        </SimpleGrid>

        <Box mt="30px">
          <Box
            maxW="1100px"
            height="auto"
            fontSize="40px"
            fontWeight="bold"
            m="auto"
            align="center"
            border="2px solid white"
            p="20px"
            bg="#1e2534"
            color="black"
            borderRadius="20px"
          >
            <GitHubCalendar
              username='AshishKohad27'
              year='last'
              // theme={'Theme'}
              blockMargin={4}
              width={"800px"}
              blockRadius={20}
              blockSize={20}
              color=''
            />
          </Box>
        </Box>
      </SimpleGrid>
    </Box>
  );
}
